import cc from "classcat";
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import Grid  from '@material-ui/core/Grid';
import { useCustomizations } from "@personicom/customizations";

const AppHeader = () => {
  const classes = buildStyles();

  const {strings, links, flags, isIframe, images, blobUrl } = useCustomizations();
  
  //Don't display the header if we're configured to run inside an iframe.
  if(isIframe) return null;

  const logo = blobUrl(images.logo);

  return (
    <Grid id="app-header" item xs={12} sm container className={classes.headerRoot}  >
      <Grid item xs container direction="row" spacing={2} alignItems="center">
        <Grid item>
          <a href={links.homeUrl} target="_blank" rel="noreferrer">
            <img
              className={cc({
                "img-responsive": flags.responsiveLogo,
                [classes.logoImage]: true,
                [classes.responsiveLogoCap]: flags.responsiveLogo,
              })}
              src={logo}
              alt={strings.logoAlt}
            />
          </a>
        </Grid>
        <Grid item xs />
        <Grid item>
          {strings.hasOwnProperty('headerInfoText') ? <Link href={links.homeUrl} className={classes.headerInfoText} target="_blank">{strings.headerInfoText}</Link > : null}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AppHeader;

const buildStyles   = makeStyles((theme : any) => ({
  headerRoot  : {
    padding: "10px 24px 8px 24px",
    backgroundColor: `${ theme.styles.header?.backgroundColor ??  theme.styles.page.backgroundColor}`,
    borderBottom  : theme.styles.header?.borderBottom ?? `${theme.styles.header?.borderBottomWidth ?? "5px"} solid ${theme.styles.page.borderColor}`, //`
    [theme.breakpoints.down('xs')]  : {
      alignItems        : "center",
      justifyContent   : "center",
    }
  },
  headerInfoText: {
    fontSize: 18,
    fontWeight: 700,
    color: theme.styles.header?.color ??  theme.styles.page.color,
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
      textAlign: "center",
    },
  },
  logoImage   : {
    height: `${ theme.styles.header?.logo?.height ?? "40px"}`, //`
    maxHeight: `${ theme.styles.header?.logo?.maxHeight ?? theme.styles.header?.logo?.height ?? "none"}`,
    width: `${ theme.styles.header?.logo?.width ?? "auto"}`,
    marginLeft : 15,
    [theme.breakpoints.down('xs')]  : {
      height    : theme.styles.header?.logo?.mobileHeight ?? 35,
      marginLeft: 0,
    }
  },
  responsiveLogoCap: {
    maxHeight: theme.styles.header?.logo?.maxResponsiveHeight ?? 72,
    width: 'auto',
    objectFit: 'contain',
  }
}));
